<template>
  <div id="app" :class="currentRouteName">
    <router-view></router-view>
    <div v-if="loading" class="loading-mask">
      <div class="spinner"></div>
      <div class="loading-text">Loading...</div>
    </div>
  </div>
</template>

<script>
import { EventBus } from './assets/script/event-bus'

export default {
  name: 'App',
  data() {
    return { loading: false }
  },
  computed: {
    currentRouteName() {
      return this.$route.name || ''
    }
  },
  mounted() {
    EventBus.on('set-loading', this.setLoading)
  },
  beforeUnmount() {
    EventBus.off('set-loading', this.setLoading)
  },
  methods: {
    setLoading(val) {
      this.loading = val
    }
  }
}
</script>

<style>
.loading-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
.loading-text {
  color: #fff;
  margin-top: 16px;
  font-size: 18px;
  font-weight: bold;
}
</style>

